import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid, Text, TextWeight } from '@focaldata/cin-ui-components'
import enCopy from 'intl/copy/en.json'
import { AppStateContext } from 'containers/State/AppState'
import { getTerms } from './getTerms'
import { getTermsRichTextElements } from './termsRichText'

const en = enCopy as Record<string, string>

const Terms = () => {
  // Resolve the selected-language code (the intl/copy key, e.g. "ja", "zh-HK")
  // the same way IntlProvider does, so the privacy-policy link is translated
  // into the respondent's chosen language.
  const {
    renderedQuestionnaire: [questionnaire],
    selectedLanguage: [selectedLanguage]
  } = useContext(AppStateContext)
  const language =
    selectedLanguage ?? questionnaire?.questionnaire.locale.language ?? 'en'
  const richTextElements = getTermsRichTextElements(language)

  return (
    <Grid container justifyContent="center">
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <Text weight={TextWeight.SemiBold}>
            <br />
            <FormattedMessage
              id="termsPage_readCarefully"
              defaultMessage={en.termsPage_readCarefully}
            />
            <br />
            <br />
          </Text>
          <Text>
            <FormattedMessage
              id="termsPage_privacyNoticeHeading"
              defaultMessage={en.termsPage_privacyNoticeHeading}
            />
          </Text>
          <Text>
            <FormattedMessage
              id="termsPage_privacyNoticeBody"
              defaultMessage={en.termsPage_privacyNoticeBody}
            />
          </Text>
        </Grid>
        {getTerms.map((term) => (
          <Grid item key={term.id}>
            <Text>
              <FormattedMessage
                id={term.titleId}
                defaultMessage={en[term.titleId]}
              />
            </Text>
            <Text>
              <FormattedMessage
                id={term.bodyId}
                defaultMessage={en[term.bodyId]}
                values={
                  richTextElements as unknown as Record<string, React.ReactNode>
                }
              />
            </Text>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default Terms
